import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { Stack } from '@mui/material'
import { ButtonSecondary } from 'components/ButtonSecondary'
import React, { useEffect } from 'react'
import { Control, useFieldArray, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { phoneInit } from 'types/phone.type'
import { PhoneItem } from './components/PhoneItem'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'

type PhoneListProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const PhoneList: React.FC<PhoneListProps> = ({ control, watch, setValue }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()
  const {
    fields: phonesFields,
    append: handleAddPhone,
    remove: handleRemovePhone,
  } = useFieldArray({
    control,
    name: 'telefones',
  })

  const phonesValues = watch('telefones')

  const isFilled = (): boolean => {
    if (phonesValues && phonesValues.length === 4) {
      return true
    }
    const lastItem = phonesValues && phonesValues[phonesValues.length - 1]
    return lastItem ? !lastItem.telefone : true
  }

  const handleDisableAddButton = (): boolean => {
    return phonesValues && !isBlockedFields ? isFilled() : true
  }

  useEffect(() => {
    if (phonesValues && !phonesValues.length) {
      setValue('telefones', [phoneInit], { shouldDirty: false })
    }
  }, [phonesValues, setValue])

  return (
    <>
      {phonesFields.map((_, i) => (
        <PhoneItem
          key={i}
          index={i}
          control={control}
          setValue={setValue}
          watch={watch}
          onRemove={handleRemovePhone}
        />
      ))}
      <Stack sx={{ ml: 2, width: '100%' }}>
        <ButtonSecondary
          maxWidth={150}
          startIcon={<AddRoundedIcon />}
          label='Telefone'
          disabled={handleDisableAddButton()}
          onClick={() => handleAddPhone(phoneInit)}
        />
      </Stack>
    </>
  )
}
